import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { InterviewTemplateDetailsActions } from '../interview-templates-details/interview-template-details.store';
import { InterviewTemplatesHttpService } from '../interview-templates-http.service';
import { actions } from './interview-templates.store';

@Injectable()
export class InterviewTemplatesEffects {
  public effect = createEffectFactory(actions, this.actions$);

  public fetchCollection = this.effect(
    actions.fetchCollection,
    ({ payload: { scope } }) =>
      this.interviewTemplatesHttpService
        .fetchCollection({ kind: scope })
        .pipe(map(data => ({ data: data.interviewTemplates, scope }))),
    { customMapOperator: mergeMap },
  );

  public updatePositions = this.effect(actions.updatePositions, ({ payload: { data } }) =>
    this.interviewTemplatesHttpService.updatePositions(data).pipe(
      switchMap(data =>
        of(actions.updatePositionsSuccess({ payload: { data: data.interviewTemplates } })),
      ),
      catchError(error => of(actions.updatePositionsFailed({ payload: { error } }))),
    ),
  );

  public removeSuccess = this.effect(
    InterviewTemplateDetailsActions.removeOnePessimisticSuccess,
    ({ payload: { data } }) => of(actions.removeOne({ payload: { data: data.id } })),
  );

  constructor(
    private actions$: Actions,
    private interviewTemplatesHttpService: InterviewTemplatesHttpService,
  ) {}
}
